import { useEffect, useState, useRef } from 'react'
import { PlusOutlined, } from '@ant-design/icons';

import { StorageModule } from '../../modules/storage';
import { userModule } from '../../modules/user';
import img_label from '../../static/image/label.png';
// import LableDrawer from '../../components/memos/drawer'
import * as apis from '../../api/user'
import * as apis2 from '../../api/networkDisk'
import type { MenuProps } from 'antd';
import useStore from '../../store/useStore'
import './index.scss'
import { CloseCircleOutlined } from '@ant-design/icons';
import MDEditor from '@uiw/react-md-editor';
import deleteIcon from '../../static/image/delete.png'
import '../../static/markDown/github-markdown.min.css';
import '../../static/markDown/prism-line-numbers.min.css';
import '../../static/markDown/prism.min.css';
import type { DatePickerProps } from 'antd';
import user_default from '../../static/image/user_default.png'
import { deepCopy, getImgUrlById, getCharCount } from '../../util';
import moment from "moment";
import Users from '../../components/memos/users'
import TaskTagPop from '../../components/memos/taskTagPop';
import MemoModal from '../../components/memos/memoModal'
import MarkDownPop from '../../components/memos/markDownPop';
import ImgPreview from '../../components/memos/imgPreview'
import arr_down from '../../static/image/arr_down.png'
import chat from '../../static/image/chat.png';
import Preview from '../../components/memos/markDownPreview';
import { sortKey } from '../../util'

import { DownOutlined, PlusCircleOutlined, MenuFoldOutlined, MenuUnfoldOutlined, EllipsisOutlined, EditOutlined, MinusCircleOutlined, EyeOutlined, DashOutlined, } from '@ant-design/icons';
import { Collapse, theme, Dropdown, Menu, Modal, Button, Input, Form, InputNumber, Tree, Popconfirm } from 'antd';
import type { DataNode, TreeProps } from 'antd/es/tree';
import { className } from '@antv/x6/lib/registry/highlighter/class';
const { TreeNode } = Tree;


interface Props {
    // history: any;
    treeData?: any
    onChange?: (...args: any[]) => void;
    onRefresh?: () => void;
    params?: any;
    hideMenu?: any
    name?: any;

}
interface State {
    txtStr: any,
    textInput: any,
    ownerId: any,
    users: any,
    data: any
}
const LevelView = (props: Props) => {
    const { store, dispatch } = useStore();
    const [list, setList] = useState<any>({});
    const [memoId, setMemoId] = useState<any>("");
    const [id, setId] = useState<any>("");
    const [ids, setIds] = useState<any>([]);
    const [itemInfo, setItemInfo] = useState<any>({});

    // const [memoModal, setMemoModal] = useState<any>(false);
    // const [cNode, setCNode] = useState<any>({});
    let cNode = useRef<any>({});
    let timeOut: any = null
    const [txt, setTxt] = useState<any>('');
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const [operationType, setOperationType] = useState<any>('');
    const [showContextMenu, setShowContextMenu] = useState<any>(true);
    const [taskVisible, setTaskVisible] = useState<any>(false);
    const [taskType, setTaskType] = useState<any>({});
    const [taskInfo, setTaskInfo] = useState<any>({});
    const [finishTime, setFinishTime] = useState<any>('');
    const [usersVisible, setUsersVisible] = useState<boolean>(false);
    const [isDeletExecutor, setIsDeletExecutor] = useState<boolean>(false);
    const [memoVisible, setMemoVisible] = useState<boolean>(false);

    const [onSelectId, setOnSelectId] = useState<any>('');


    //是否以原来格式展示
    const [isOriginType, setIsOriginType] = useState<boolean>(true);
    const [permissionsList, setPermissionsList] = useState<any>([]);

    let codeArr: any = [];
    const [form] = Form.useForm();
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [state, setState] = useState<State>({
        textInput: '',
        txtStr: '',
        ownerId: '',
        users: [],
        data: {}
    })
    useEffect(() => {
        if (!store.taskVisible) {
            init()
            console.log('props.name', props.name)
        }
    }, [store.taskVisible])
    useEffect(() => {
        console.log('store.subjectInfo.subjectId', store.subjectInfo.data)
        if (store.subjectInfo?.data?.permissions) {
            if (!store.relationbelongtos_superid) {
                setTimeout(() => {
                    init()
                }, 1000);
            }
            setPermissionsList(store.subjectInfo.data.permissions)
        }
    }, [store.subjectInfo.data])
    useEffect(() => {
        // if (!store.relationbelongtos_superid) {
        //     setTimeout(() => {
        //         init()
        //     }, 1000);
        // }
    }, [store.relationbelongtos_superid])
    useEffect(() => {
        // init()
        getId()
    }, [])
    useEffect(() => {
        dealData()
    }, [props.treeData])
    useEffect(() => {
        setId(props.params?.subjectId || store.subjectInfo.subjectId)
        setMemoId(props.params?.memoId || null)
        state.users = props.params?.users || null
        state.data = props.params?.data || null
        setState(state)
    }, [props.params])
    useEffect(() => {
        console.log('itemInfo', itemInfo)
        dispatch({
            type: 'SET_MEMOINFO',
            data: itemInfo
        });
    }, [itemInfo])


    useEffect(() => {
        //修改标签
        if (JSON.stringify(store.calendarLable) != '{}') {
            console.log('修改标签', store.calendarLable)
            // setLabelData([{ ...store.calendarLable }])
            // memoTask(props.match.params.dataType)
            init()
        }
    }, [store.calendarLable,])
    useEffect(() => {
        if (store.viewHierarchyInfo?.chooseLevel > 0) {
            let _expandedKeys = getExpandedKeys(list, Number(store.viewHierarchyInfo?.chooseLevel - 1));
            setExpandedKeys(_expandedKeys)
        } else {
            setExpandedKeys([])
        }
        //收起所有文段
        let nodeList: any = document.querySelectorAll(".middle-info-auto")
        if (nodeList.length > 0) {
            for (let i: any = 0; i < nodeList.length; i++) {
                // nodeList[i].style.backgroundColor = "red";
                nodeList[i].classList.remove("middle-info-auto")
                console.log(nodeList[i].classList)
            }
        }
    }, [store.viewHierarchyInfo?.chooseLevel,])
    const getExpandedKeys = (data: any, level: any) => {

        const expandedKeys: any = [];
        data.forEach((node: any) => {
            // console.log('getExpandedKeys', node)
            if (node.level === level) {
                expandedKeys.push(node.hierarchyCatalogue + '_' + node.id);
            } else if (node.childMemos) {
                expandedKeys.push(...getExpandedKeys(node.childMemos, level));
            }
        });
        return expandedKeys;
    };


    useEffect(() => {


        window.addEventListener('keydown', onKeyDown, this) // 添加全局事件
        return () => {
            window.removeEventListener('keydown', onKeyDown, this) // 销毁
        }
    }, [store.memoModal])
    // useEffect(() => {
    //     //监听全局公共组件图标
    //     window.addEventListener('click', closeclick);
    //     return () => {
    //         window.removeEventListener('click', closeclick);
    //     }
    // }, []);
    // const closeclick = (e: any) => {
    //     const roll = (item: any): boolean => {
    //         console.log(item, item.getAttribute("class"))
    //         if (item.getAttribute("class") === 'content') {
    //             return true;
    //         } else if (item.parentElement && item.parentElement.tagName !== 'item') {
    //             return roll(item.parentElement)
    //         } else {
    //             return false;
    //         }
    //     }
    //     const isSvg = roll(e.target);
    //     if (isSvg) {
    //         let _div = e.target.parentElement.parentElement
    //         if (_div?.classList.contains('middle-info-auto')) {
    //             _div?.classList.remove('middle-info-auto');
    //         } else {
    //             _div?.classList.add('middle-info-auto');
    //         }
    //     }
    // }
    const dealData = () => {
        console.log('dealData', props.treeData)
        if (!props.treeData) return
        const res: any = props.treeData;
        setList(res)

    }
    //将初始化的数据插入编译后的字段
    const init = async () => {
        props.onRefresh && props.onRefresh()




    }

    //获取父级内容列表
    const getParent = (id: any) => {
        let parent: any = [];
        const _fun = (mapList: any, pid: any) => {


            mapList.map((item: any) => {
                if (item.id === id) {
                    parent = mapList
                    return;
                }
                if (item.childMemos?.length > 0 && parent?.length == 0) {
                    _fun(item.childMemos, item.id)
                }
            })
            return parent
        }
        return _fun(list, memoId)
    }

    //获取兄弟元素的id
    const getPrevId = (id: any) => {
        const parentList = getParent(id);
        let _data: any = {}
        parentList.map((item: any, iid: any) => {
            if (item.id === id) {
                _data = iid > 0 ? parentList[iid - 1] : parentList[1]
            }
        })
        return _data?.id
    }

    //获取父级ID
    const getParentId = (id: any) => {

        const _fun = (mapList: any, pid: any) => {
            console.log(mapList, pid)
            let parentId: any = "";
            mapList.map((item: any) => {

                if (item.id === id) {
                    parentId = pid
                    return;
                }
                if (item.childMemos.length > 0) {
                    _fun(item.childMemos, item.id)
                }
            })
            return parentId
        }
        return _fun(list, memoId)
    }

    //点击右键执行事件
    const clickFun = (obj: any, item: any, parentId: any) => {
        // if (!item.isNodisabled) return
        switch (item.label) {
            case "编辑":
                console.log('编辑', obj)
                setOperationType('memos')
                setIsAdd(false)
                setTxt(obj.content)
                state.txtStr = obj.content
                setState(state)
                setCNode(obj)
                // setMemoModal(true)
                labelPop(obj.mimeType, { data: obj })
                // setMemoVisible(true)
                setShowContextMenu(false)

                break;
            case "新建":
                console.log('新建', obj, item, "parentId=", parentId)
                setIsAdd(true)
                // setTxt('')
                // state.txtStr = ''
                // setState(state)
                // setCNode({
                //     ...obj, ...{
                //         parentId,
                //         mimeType: 'text'
                //     }
                // })
                // // setMemoModal(true)
                // setMemoVisible(true)
                // setShowContextMenu(false)


                setTxt('')
                state.txtStr = ''
                setState(state)
                setOperationType('memos')
                setIsAdd(true)
                setCNode({
                    ...obj, ...{
                        parentId,
                        mimeType: 'text'
                    }
                })
                if (obj.level != 1) {
                    dispatch({
                        type: 'SET_RELATIONBELONGTOS_SUPERID',
                        data: parentId
                    });
                }
                setMemoModal(true, 'memos', true)
                setShowContextMenu(false)
                break;
            case "删除":
                console.log('删除', obj, parentId)
                if (!props.hideMenu) {
                    apis.setHierarchy(id, {
                        $operate$: "delete",
                        id: obj.id,
                        superId: parentId
                    })?.then((res: any) => {
                        if (res.ok) {
                            init()
                        }
                    })
                } else {
                    apis2.deleteMemo(obj.id)?.then((res: any) => {
                        console.log(res)
                        if (res.ok) {
                            init()
                        }
                    })
                }


                break;
            case "移除":
                apis.setHierarchy(id, {
                    $operate$: "remove",
                    id: obj.id,
                    superId: parentId
                })?.then((res: any) => {
                    if (res.ok) {
                        init()
                    }
                })
                break;
            case "升级":
                apis.setHierarchy(id, {
                    $operate$: "upgrade",
                    id: obj.id,
                    superId: parentId,
                    superSuperId: getParentId(parentId)//上上级便签id
                })?.then((res: any) => {
                    if (res.ok) {
                        init()

                    }
                })
                break;
            case "降级":
                const prevId = getPrevId(obj.id)
                apis.setHierarchy(id, {
                    $operate$: "degrade",
                    id: obj.id,
                    superId: parentId,
                    newSuperId: prevId//新的上级便签id
                })?.then((res: any) => {
                    if (res.ok) {
                        init()

                    }
                })
                break;
        }
        setShowContextMenu(false)
    }

    const menulist = (obj: any, parentId: any) => {
        let list: any = []
        let pl_userInfo: any = localStorage.getItem('pl_userInfo')
        pl_userInfo = JSON.parse(pl_userInfo)
        console.log(permissionsList, permissionsList.some((i: any) => i == 'memo_save'))
        //未讨论&&非创建用户
        if (!props.hideMenu) {
            if ((state.users?.length > 0 && state.users.indexOf(obj.ownerId) > -1) || obj.ownerId == pl_userInfo.id) {
                list = [...list, ...[{
                    label: "编辑",
                    icon: <EditOutlined />,
                    isNodisabled: permissionsList.some((i: any) => i == 'memo_save')
                }]]
            }
            list = [...list, ...[{
                label: "新建",
                icon: <PlusCircleOutlined />,
                isNodisabled: permissionsList.some((i: any) => i == 'memo_insert')
            }]]
            list = [...list, ...[{
                label: "移除",
                icon: <MinusCircleOutlined />,
                isNodisabled: permissionsList.some((i: any) => i == 'memo_remove')

            }]]
            if (getParent(obj.id).length > 1) {
                list = [...list, ...[{
                    label: "降级",
                    icon: <MenuUnfoldOutlined />,
                    isNodisabled: permissionsList.some((i: any) => i == 'memo_degrade')

                }]]
            }
            if (parentId && parentId !== memoId) {
                list = [...list, ...[{
                    label: "升级",
                    icon: <MenuFoldOutlined />,
                    isNodisabled: permissionsList.some((i: any) => i == 'memo_upgrade')
                }]]
            }
        }
        //创建用户等于登录用户
        if (obj.ownerId == pl_userInfo.id) {
            list = [...list, ...[{
                label: "删除",
                icon: <img src={deleteIcon} />,
                isNodisabled: permissionsList.some((i: any) => i == 'memo_delete')

            }]]

        }

        console.log('当前兄弟元素', obj.content, getParent(obj.id))

        return showContextMenu ? <div className="contextMenu">
            {list.map((item: any, id: any) => {
                if (item.label == '删除' || item.label == '移除') {
                    return <Popconfirm
                        key={id}
                        title={`确定要${item.label}？`}
                        okText="确定"
                        cancelText="取消"
                        onConfirm={() => clickFun(obj, item, parentId)}
                    >
                        {item.icon}{item.label}
                    </Popconfirm>
                }
                return <p key={id} className={(item.isNodisabled) ? "" : "menuItemDisabled"} onClick={(e) => { e.stopPropagation(); if (!item.isNodisabled) return; clickFun(obj, item, parentId) }}>{item.icon}{item.label}</p>
            })}
        </div> : <></>
    }


    const tagsDoubleClick = (ele: any, item: any) => {
        dispatch({
            type: 'SET_MEMOINFO',
            data: { data: item }
        });
        dispatch({
            type: 'SET_TASKTABFUN',
            data: {
                ...ele, ...{
                    memoId: item.id
                }
            }
        });

    }
    const taskTab = [{
        class: 'item1',
        name: '任务计划',
        label1: '计划完成时间',
        label2: '预计工时h',

    },
    {
        class: 'item2',
        name: '开始执行',
        label1: '预计完成时间',
        label2: '预计工时h'
    },
    {
        class: 'item3',
        name: '任务完成',
        label1: '实际完成时间',
        label2: '实际工时h'
    }, {
        class: 'item4',
        name: '版本计划',
        label1: '版本号',
        label2: ''
    }]

    const tagsType = (item: any) => {
        // console.log('tags', item)
        item.isShow = false
        return <div className='cards-list'>
            <div className='cards-list-content'>
                {item.tagMetas && item.tagMetas.map((ele: any, id: any) => {
                    if (ele.type !== 'attachment') {
                        return
                    }
                    let classStr = ''
                    switch (ele.name) {

                        case '开始执行':
                            classStr = "card1"
                            break;
                        case '任务完成':
                            classStr = "card2"
                            break;
                        default:
                            classStr = "card0"
                    }
                    if (ele.notation === 'ReleaseTag') {
                        return <div className={"card card3"} onDoubleClick={() => tagsDoubleClick(ele, item)}>
                            <h4>版本计划</h4>
                            <p>版本号<span>{ele.instance.release}</span></p>
                        </div>
                    }
                    return <div key={id} className={"card " + classStr} onDoubleClick={(e: React.MouseEvent) => { e.stopPropagation(); tagsDoubleClick(ele, item) }}>
                        <h4>{ele.name}</h4>
                        <p><span>起止时间</span>{ele.instance?.startTime?.split('T')[0]} ~ {ele.instance?.finishTime?.split('T')[0]}</p>
                        <p><span>预计工时</span>{ele.instance.manHour}</p>
                        <p><span>执行人</span>{ele.instance.executorUser?.username}</p>
                    </div>
                })}
            </div>
        </div>
    }
    const labelDiv = (item: any, parentId: any, divId?: any) => {
        // console.log(isOriginType, item.id, itemInfo?.data?.id)
        let _class: any = taskTab.filter((i: any) => item.tagMetas[item.tagMetas?.length - 1]?.name == i.name)[0]?.class
        let _ImageTag: any = item.tagMetas?.filter((i: any) => i.notation === 'ImageTag' || i.notation === 'ImgNotesTag') || []
        return <div data-flex='main:justify cross:top' className={` showtigger content`} ><div className='content-class' data-flex='main:left cross:top' ><div className={`item ${_class}`}></div><span onClick={(e) => {
            e.preventDefault()
        }} onDoubleClick={(e) => {
            e.preventDefault()
            clickFun(item, { label: "编辑" }, parentId)
        }}
        >
            {/* <>{console.log('expandedKeys', onSelectId, item.id, expandedKeys, isOriginType, itemInfo)}</> */}
            {onSelectId == item.id ? <>
                {item.mimeType?.indexOf('image') > -1 && <>
                    <div><div dangerouslySetInnerHTML={{
                        __html: `<div>${item.content.replace(/\n/g, '</br>')}<div>`
                    }}></div>
                        <div className='memoImg' style={{ backgroundImage: `url(${getImgUrlById(_ImageTag[0].instance.imagePath)})` }}>
                        </div>
                        <EyeOutlined className='ml-10 icon_hover' onClick={() => {
                            setCNode(item)
                            dispatch({
                                type: 'SET_IMGPREVIEW',
                                data: true
                            });
                        }} />
                    </div></>}
                {(item.mimeType === "text/markdown")
                    && <Preview content={item.content} isNoModal={true} id={item.id} />}
                {(!item.mimeType || item.mimeType?.indexOf('image') == -1 || item.mimeType !== "text/markdown") && <div dangerouslySetInnerHTML={{
                    __html: `<div>${item.content.replace(/\n/g, '</br>')}<div>`
                }}></div>}
            </> : <div dangerouslySetInnerHTML={{
                __html: `<div>${item.content.replace(/\n/g, '</br>')}<div>`
            }}></div>}
            {/* {(item.mimeType === "text/markdown" && isOriginType && item.id == itemInfo?.data?.id) && <>
                {isOriginType ? <>{item.content}</> : <Preview content={item.content} isNoModal={true} id={item.id} />}</>} */}
            {/* {!item.mimeType && <div dangerouslySetInnerHTML={{
                __html: `<div>33${item.content.replace(/\n/g, '</br>')}<div>`
            }}></div>} */}
        </span>
        </div>

            <div className='showtigger showtigger-icon' onDoubleClick={(e) => {
                clearTimeout(timeOut);
                e.preventDefault()
                if (!props.hideMenu) {
                    clickFun(item, { label: "编辑" }, parentId)
                }
            }}>

                {item?.discussionId && <img className={'chaticon'}
                    onMouseDown={async (e) => {
                        e.stopPropagation();
                        setItemInfo({ data: item })
                        dispatch({
                            type: 'SET_SHOWCHATTYPE',
                            data: ''
                        });
                        if ((window as any).cdi && ((window as any).cdi === item?.discussionId)) {
                            dispatch({
                                type: 'SET_CHATID',
                                data: ''
                            });
                            dispatch({
                                type: 'SET_CHATDISCUSSIONID',
                                data: ''
                            });
                            dispatch({
                                type: 'SET_CLOSESHOWALL',
                                data: null
                            });
                        } else {
                            dispatch({
                                type: 'SET_CHATID',
                                data: item.id
                            });
                            dispatch({
                                type: 'SET_CHATDISCUSSIONID',
                                data: item?.discussionId
                            });
                            dispatch({
                                type: 'SET_CLOSESHOWALL',
                                data: ['showChat']
                            });
                        }
                    }}
                    src={chat} />}
                {(item.tagMetas.length > 0) && <img src={img_label}
                    className='chaticon' style={{ right: '40px' }}
                    onMouseDown={async (e) => {
                        e.stopPropagation();
                        setItemInfo({ data: item })
                        // setTimeout(() => {
                        if (item.id === (window as any).memoInfo?.data?.id) {
                            dispatch({
                                type: 'SET_SHOWDRAWLABEL',
                                data: !(window as any).showDrawLabel
                            });
                        } else {
                            dispatch({
                                type: 'SET_SHOWDRAWLABEL',
                                data: true
                            });
                        }
                        // }, 500);
                    }
                    }
                />}
                <EllipsisOutlined onClick={(e) => {
                    e.stopPropagation()
                    console.log("onSelectId", onSelectId)
                    if (onSelectId == item.id) {
                        setOnSelectId('')
                    } else {
                        setOnSelectId(item?.id)
                        if (item.mimeType === "text/markdown") {
                            setIsOriginType(false)
                        } else {
                            setIsOriginType(true)
                        }
                        setItemInfo({ data: item })
                    }


                    // if (divId?.classList.contains('middle-info-auto')) {
                    //     divId?.classList.remove('middle-info-auto');
                    // } else {
                    //     divId?.classList.add('middle-info-auto');
                    // }
                }} />
            </div>

        </div>
    }

    const getId = async () => {
        let res: any = await apis2.sequenceSerial()
        if (res.ok) {
            let _ids = ids.concat(res.data);
            setIds(_ids)
        }
    }
    const saveNode = (type: any) => {
        console.log('saveNode', cNode.current)
        //不可新建空白注释
        if (type === 'comments' && isAdd && !state.txtStr) return
        if (isAdd) {
            if (ids.length === 1) {
                getId()
            }

            apis.setHierarchy(id, {
                $operate$: "insert",
                id: ids[0],
                superId: cNode.current.parentId,
                content: state.txtStr
            })?.then((res: any) => {
                if (res.ok) {
                    init()
                    ids.splice(0, 1)
                    setIds(ids)
                    setShowContextMenu(true)
                }
            })

        } else {
            if (cNode.current.mimeType === 'text/markdown') {
                apis2.putMemoNotation(cNode.current.id, 'MarkdownTag', { content: state.txtStr })?.then((res: any) => {
                    if (res.ok) {
                        init()

                    }
                })
            } else {
                let params = state.data
                // if (!state.data) {
                //     params = {
                //         memoId: cNode.current.id,
                //         subject:cNode.current.topicNames[0]
                //     }
                // }
                apis2.putExcellingTopic(id, {
                    ...params, ...{
                        $operate$: "save",

                        memos: [{
                            ...cNode.current, ...{
                                $operate$: "save",
                                superId: cNode.current.parentId,
                                content: state.txtStr,
                            }
                        }],
                        relationBelongTos: [],
                        comments: []
                    }
                })?.then((res: any) => {
                    if (res.ok) {
                        init()
                        setShowContextMenu(true)
                    }
                })
            }



        }
        setMemoModal(false)
        setShowContextMenu(true)
        setTimeout(() => {
            setMemoVisible(false)
        }, 1000);
    }
    const setMemoModal = (e: any, _operationType?: any, _isAdd?: any) => {
        if (_isAdd) {
            // dispatch({
            //     type: 'SET_CNODE',
            //     data: null
            // });
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { content: "", data: {} }
            });
            dispatch({
                type: 'SET_MEMOINFO',
                data: { content: "", data: {} }
            });
        }
        console.log('OperationType', operationType, isAdd)
        console.log('OperationType1', e, _operationType, _isAdd)
        dispatch({
            type: 'SET_MEMOMODAL',
            data: {
                visible: e,
                operationType: _operationType || '',
                isAdd: _isAdd || false
            }
        });
    }
    const onDragOver = (event: any, node: any) => {
        console.log('onDragOver', event, node)
    }
    const onDrop: TreeProps['onDrop'] = info => {
        let _data: any = info.dragNode['data']
        console.log('onDrop', info)
        console.log('id', _data.id)
        console.log('newSuperId', info.node['data'].superId)
        console.log('superId', _data.superId)
        console.log('forwardId', _data.forwardId,)
        console.log('getParent', getPrevId(_data.id))

        let _params = {
            "$operate$": "forward",
            id: _data.id,
            newSuperId: info.node['data'].superId,
            superId: _data.superId,
            forwardId: info.node['data'].id
        }
        console.log(_params)
        apis.setHierarchy(id, _params)?.then((res: any) => {
            if (res.ok) {
                init()
            }
        })

    }
    const setCNode = (node: any) => {
        console.log('node', node)
        if (node) {
            node.$operate$ = "save"
        }
        if (node?.data?.type !== 'menu' || !node) {
            cNode.current = node

            dispatch({
                type: 'SET_CNODE',
                data: (node) ? node : null
            });
        }
        if (node) {
            dispatch({
                type: 'SET_MEMOINFO',
                data: { label: node.content, data: { ...node } }
            });
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { label: node.content, data: { ...node } }
            });
        }

    }
    //标签弹出框类型
    const labelPop = (mimeType?: any, node?: any) => {
        if (!mimeType) {
            console.log(node)
            // setMemoModal(true, 'memos', false)
            setMemoModal(true, node?.data?.type, false)
        } else {
            setMemoModal(false, node?.data?.type, false)
            dispatch({
                type: 'SET_LABELPOP',
                data: true
            });
        }
    }
    const onKeyDown = (e: any) => {
        if ((e.keyCode !== 17 && e.keyCode !== 13) || codeArr.length > 2) {
            codeArr = []
            return
        }
        if (codeArr[0] == 13) {
            codeArr = []
            return
        }
        if (codeArr.indexOf(e.keyCode) < 0) {
            codeArr.push(e.keyCode)
        }

        if (store.memoModal && codeArr[0] === 17 && codeArr[1] === 13) {
            codeArr = []
            saveNode('memos')

        }
    }
    const renderDropdown = (item: any, parentId: any, _keys: any) => {
        let divElement = (document as any).getElementById(`${_keys}`)
        return (
            <Dropdown onOpenChange={(e) => {
                console.log(e)
                if (e) {
                    setShowContextMenu(true)
                }
            }} trigger={['contextMenu']} dropdownRender={() => menulist(item, parentId)}>
                <div id={_keys} className={`middle-info  ${(onSelectId == item.id) ? 'middle-info-auto' : ''}  level-${item.level} id-${_keys} `}
                    onClick={(e: any) => {
                        //使用原生选中背景，暂时解除e.stopPropagation()的屏蔽
                        // e.stopPropagation()  
                        clearTimeout(timeOut);
                        console.log('isOriginTY peShow', isOriginType)
                        if (item.mimeType === "text/markdown") {
                            setIsOriginType(false)
                        } else {
                            setIsOriginType(true)
                        }
                        setItemInfo({ data: item })
                        timeOut = setTimeout(() => {
                            divElement = (document as any).getElementById(`${_keys}`)
                            // console.log(e.target.className, e.target.className.includes('chaticon'))
                            //点击icon不展开
                            if (e.target.className.includes('chaticon')) {
                                return
                            }
                            // if (divElement?.classList.contains('middle-info-auto')) {
                            //     if (e.target.className.includes('showtigger') || e.target.className.includes('cards-list')) {
                            //         divElement?.classList.remove('middle-info-auto');
                            //     }
                            // } else {
                            //     divElement?.classList.add('middle-info-auto');
                            // }
                        }, 500)
                    }}
                > {labelDiv(item, parentId, divElement)}
                    {/* {tagsType(item)} */}
                </div>

            </Dropdown >
        );
    }
    const renderTreeNodes = (data: any, parentId: any) => {
        let _data: any = data.sort(sortKey('ordering'))

        // console.log("parentId", parentId, data)
        return data.map((item: any, index: any) => {
            // item.uuid = uuidv4()
            let _item: any = {
                "id": item.id,
                "superId": parentId,
            }
            // console.log('item.level + index + item.id', item.level + index + item.id)
            let _keys = item.hierarchyCatalogue + '_' + item.id
            if (item.childMemos) {
                return (
                    <TreeNode selectable={true} data={_item} title={renderDropdown(item, parentId, _keys)} key={_keys}>

                        {renderTreeNodes(item.childMemos, item.id)}

                    </TreeNode>
                );
            }
            return <TreeNode selectable={true} data={_item} title={renderDropdown(item, parentId, _keys)} key={_keys} />;
        });
    };
    const onSelect = (selectedKeys: any, info: any) => {
        // Handle the selection logic here
        console.log('Selected keys:', selectedKeys);
        console.log('Additional info:', info);
    };
    // }
    return (
        <>
            {/* props.name == '待处理' || !props.name */}
            {(props.name == '待处理' || !props.name) && <Button className={`${!props.name ? 'mt-10' : ''} btn-add icon_hover mr-10`} onClick={() => {
                setMemoModal(true, 'memos', true)
            }} >新建</Button>}
            <div className='viewbg' id='viewbg'>
                {list.length > 0 && <Tree autoExpandParent
                    showLine
                    draggable={true}
                    // onDragOver={()=>{onDragOver}}
                    onDrop={onDrop}
                    switcherIcon={<DownOutlined onClick={(e) => {
                        console.log(e)
                    }} />}
                    expandedKeys={expandedKeys} onSelect={(selectedKeys, info: any) => {
                        console.log('selectedKeys', selectedKeys)
                        if (selectedKeys.length == 0) {
                            setOnSelectId('')
                        } else {
                            setOnSelectId(info?.node?.data?.id)
                        }
                    }} onExpand={(bool: any, row) => {
                        console.log('onExpand =', bool)
                        console.log('onExpand -', row)
                        setItemInfo({ data: row })
                        let check_key: any = row.node.key
                        check_key = check_key.split('_')[0]
                        console.log(check_key)
                        let _keys: any = []
                        bool.map((i: any) => {
                            if (i.indexOf(check_key) !== 0) {
                                _keys.push(i)
                            }
                        })
                        console.log(_keys)
                        if (_keys) {
                            if (row.expanded) {
                                setExpandedKeys(bool)
                            } else {
                                setExpandedKeys(_keys)
                            }
                        } else {

                        }
                    }}>{renderTreeNodes(list, memoId)}</Tree>}
            </div>
            {/* <TaskTagPop visible={taskVisible} onClose={() => { setTaskVisible(false) }} onRefresh={() => { init() }} /> */}
            {/* <MarkDownPop onRefresh={() => { init() }} /> */}
            {/* <MemoModal openVisible={true} onClose={() => { setMemoVisible(false) }} visible={memoVisible} saveNode={(e) => { saveNode(e) }} isAdd={isAdd} operationType={operationType} change={(e) => {
                setTxt(e)
                state.txtStr = e
                setState(state)
            }} /> */}
            {/* <ImgPreview /> */}
            {/* <LableDrawer type={'memo'} className={'customDraw'} title={'任务内容'} subjectData={store.memoInfo} visible={store.showDrawLabel} onClose={() => {
                dispatch({
                    type: 'SET_SHOWDRAWLABEL',
                    data: false
                });
            }} /> */}
        </>

    )
}

export default LevelView
